export const pcPageConfig = {
  "title": "LTV",
  "titleCN": "LTV",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/monetization/ltv",
  "defaultTab": "ltv",
  "tabList": [
    {
      "id": "ltv",
      "tabName": "LTV",
      "tabNameCN": "LTV",
      "isHaveNotification": true,
      "notificationPath": "/monetization/ltv",
      "path": "/monetization/ltv",
      "logConfig": {
        "pageId": "201501",
        "pageName": "monetizationLTV",
        "extInfo": "monetizationLTV",
        "pagePath": "/monetization/ltv"
      },
      "filters": [
        {
          "name": "LtvFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "monetization/ltv",
          "componentList": [
            {
              "name": "MetricInfo",
              children: [
                {
                  "name": "MetricComponent",
                  "path": "monetization/ltv",
                  "componentKey": "LtvLineChart",
                  "config": {
                    "props": {
                      "config": {
                        "api": "/api/v1/dashboard/monetization/ltv/linechart"
                      }
                    }
                  }
                },
                {
                  "name": "MetricComponent",
                  "path": "monetization/ltv",
                  "componentKey": "LtvTrackingTable",
                  "config": {
                    "props": {
                      "config": {
                        "accumulateSelectMultipleBoxClassName": "dbd-monetization-ltv-casual-tracking-table__accumulate-select-multiple-box",
                        "api": {
                          "tableApi": "/api/v1/dashboard/monetization/ltv/table",
                          "tableDownloadApi": "/api/v1/dashboard/monetization/ltv/table/download"
                        },
                        "keyDaysConfig": [
                          {
                            "value": 0,
                            "enName": "Key Days",
                            "cnName": "关键日"
                          },
                          {
                            "value": 30,
                            "enName": "1 ~ 30 Days",
                            "cnName": "1 ~ 30 日"
                          },
                          {
                            "value": 60,
                            "enName": "1 ~ 60 Days",
                            "cnName": "1 ~ 60 日"
                          },
                          {
                            "value": 90,
                            "enName": "1 ~ 90 Days",
                            "cnName": "1 ~ 90 日"
                          },
                          {
                            "value": 180,
                            "enName": "1 ~ 180 Days",
                            "cnName": "1 ~ 180 日"
                          },
                          {
                            "value": 360,
                            "enName": "1 ~ 360 Days",
                            "cnName": "1 ~ 360 日"
                          }
                        ]
                      }
                    }
                  }
                },
              ],
            },
          ]
        }
      ]
    }
  ]
};
